import { colorToCss, createLinearGradient } from "./color"

export interface INumericValueColor {
    Value: number
    Colour: number[]
}


export function getColorForValue(colors: number[][], value: number, minValue: number, maxValue: number, debug = false): number[] {

    var n = colors.length
    var diff = Math.max(0, value - minValue)
    var rank = Math.floor(n / 2)

    if (minValue < maxValue) {
        rank = Math.floor(diff / ((maxValue - minValue) / n))
        rank = Math.max(0, Math.min(rank, n - 1))
    }

    return colors[rank]

}
export function getHorizontalBarBackgroundStyle(value: number, minValue: number, maxValue: number, color: number[]) {

    let values = [{ value: value, color: color }]

    return getHorizontalBarBackgroundStyle2(values, minValue, maxValue)

}

export function getHorizontalBarBackgroundStyle2(values: { value: number, color: number[] }[], minValue: number, maxValue: number) {

    let pct: number
    let style: string = ""

    values.forEach(i => {

        let value = Math.min(maxValue, Math.max(minValue, i.value))

        var diff = (i.value - minValue)
        var width = (maxValue - minValue)

        let prevPct = pct
        pct = Math.round(100 * diff / width)

        let cssColor = colorToCss(i.color)

        style += `${cssColor} ${prevPct || 0}%, ${cssColor} ${pct}%, `

    })

    style += `transparent ${pct}%`

    return {
        "background": "linear-gradient(to right, " + style + ")",
    }

}

export abstract class NumericValueColorProvider {

    abstract getColors(): number[][]
    abstract getColorForValue(value: number, minValue?: number, maxValue?: number): number[]

    getHorizontalBarBackgroundStyle(value: number, minValue: number, maxValue: number, color?: number[]) {

        color = color || this.getColorForValue(value, minValue, maxValue)

        return getHorizontalBarBackgroundStyle(value, minValue, maxValue, color)

    }

}

export function createNumRangeProvider(color1: number[] = [255, 239, 156], color2: number[] = [255, 113, 40], number: number = 10) {

    const gradient = createLinearGradient([color1, color2], number)

    return new NumericRangeColorProvider(gradient)

}

export function createValuedColorsProvider(colors: INumericValueColor[], referenceColor?: number[], dynamicScale?: boolean) {

    return new ValuedColorsProvider(colors, referenceColor, dynamicScale)

}

export class NumericRangeColorProvider extends NumericValueColorProvider {

    constructor(private colors: number[][], private readonly debug = false) {
        super()
    }

    getColors() {
        return [...this.colors]
    }

    getColorForValue(value: number, minValue: number, maxValue: number): number[] {
        return getColorForValue(this.colors, value, minValue, maxValue, this.debug)
    }

}


export class ValuedColorsProvider extends NumericValueColorProvider {

    private baseColors: number[][]
    private minValue: number
    private maxValue: number

    constructor(private colors: INumericValueColor[], private referenceColor?: number[], private dynamicScale?: boolean) {

        super()

        this.colors = colors.sort((c1, c2) => c1.Value - c2.Value)

        if (colors.length > 0) {
            this.minValue = this.colors[0].Value
            this.maxValue = this.colors[this.colors.length - 1].Value
        }

        this.baseColors = this.colors.map(c => c.Colour)

    }

    getColors() {
        return this.colors.map(c => c.Colour)
    }

    getValuedColors() {
        return this.colors
    }

    getReferenceColor() {
        return this.referenceColor
    }

    getMinValue(): number {
        return this.minValue
    }

    getMaxValue(): number {
        return this.maxValue
    }

    getValueIndex(value: number): number {

        for (var i = 0; i < this.colors.length; i++) {

            var item = this.colors[i]

            if (item.Value > value) {
                return (i ? (i - 1) : i)
            }

        }

        return this.colors.length - 1

    }

    getColorForValue(value: number, minValue: number, maxValue: number): number[] {

        let color: number[]

        if (this.dynamicScale) {
            color = getColorForValue(this.baseColors, value, minValue, maxValue)
        }
        else {
            const index = this.getValueIndex(value)
            color = this.colors[index]?.Colour
        }

        return color

    }

    getHorizontalBarBackgroundStyle(value: number, minValue: number, maxValue: number, color?: number[]) {

        color = color || this.referenceColor || this.getColorForValue(value, minValue, maxValue)

        return getHorizontalBarBackgroundStyle(value, this.minValue, this.maxValue, color)

    }

}
